@if (visible) {
    <div class="toast-container" [ngClass]="{ 'toast-msg__complete__show': type == 'success', 'toast-msg__complete__error': type == 'error', 'toast-msg__complete__warning': type == 'warning' }">
        <div class="toast-wrapper">
            <div class="f-row toaster-value-row">
                <div class="toast-icon">
                    <mat-icon fontSet="material-symbols-outlined" class="mat-icon check-icon">
                        @switch (type) {
                            @case ('success') {
                                check_circle
                            }
                            @case ('error') {
                                info
                            }
                            @case ('warning') {
                                info
                            }
                        }
                    </mat-icon>
                </div>
                <div class="toast-content">
                    <span class="toast-header"> </span>
                    <div class="toast-desc">
                        <p>{{message}}</p>
                    </div>
                </div>
            </div>
            <div class="actions">
                <button type="button" class="button-as-span sort-close" (click)="$event.preventDefault(); close()">
                    <mat-icon fontSet="material-symbols-outlined"> close </mat-icon>
                </button>
            </div>
        </div>
    </div>
}